module.exports = __webpack_public_path__ + "img/944.d3f18ee7.png";